/*-----NAV CART BUTTON RESPONSIVE -----*/

function setup_for_width(mql) {
  if (mql.matches) {
        $('#navbarcart').appendTo('.navbar-header');
    	$('.pp-title').appendTo('.pp-title-xs');
    } else {
        $('#navbarcart').appendTo('.navbar-collapse').insertAfter($("ul.navbar-nav"));
      	$('.pp-title').appendTo('.pp-title-sm');
    }	
};
var mql = window.matchMedia("screen and (max-width: 767px)"); 
mql.addListener(setup_for_width);
setup_for_width(mql); 


/*-----NAVBAR TOOGLE------*/

$(document).ready(function () {
  $(".navbar-toggle").on("click", function () {
    $(this).toggleClass("active");
  });
});


/*----- PRODUCTION BOXES------*/

jQuery(function($){
	var max_col_height = 0; 
	$('.pbs-item').each(function(){ 
		if ($(this).height() > max_col_height) { 
			max_col_height = $(this).height(); 
		}
	});
	$('.pbs-item').height(max_col_height);
});

/*------ CHECKBOX ---------*/


